import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=c337f268&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"
import style0 from "./BaseButton.vue?vue&type=style&index=0&id=c337f268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c337f268",
  null
  
)

export default component.exports